module.exports = __webpack_public_path__ + "img/x-force.fbc7e389.svg";